// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22kVU","colMin":"styles_colMin__3zImx"};